/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import _ from 'lodash';
import { jwtDecode } from 'jwt-decode';

import Layout from 'components/partials/Layout';
import { getSource } from 'models/source';
import { checkRegisterStep, updateRegisterStep } from 'models/user';
import MembershipType from './components/MembershipType';
import CreateProfile from './components/CreateProfile';
import PhoneEnterence from './components/PhoneEnterence';
import CodeEnterence from './components/CodeEnterence';
import CreateCompany from './components/CreateCompany';
import EmailVerification from './components/EmailVerification';
import EmailVerifySuccess from './components/EmailVerifySuccess';
import RegisterSuccess from './components/RegisterSuccess';
import RegisterSteps from './components/RegisterSteps';

const Register = ({ step }) => {
  const router = useRouter();
  const [pageLoading, setPageLoading] = useState(true);

  const [sources, setSources] = useState({});

  const [userState, setUserState] = useState({
    name: '',
    surname: '',
    email: '',
    country: '',
    password: '',
    confirmPassword: '',
    membershipType: '',
    agreement_kvkk: false,
    agreement_messaging: false,
    agreement_distance_selling: false,
    phoneCode: '',
    phone: '',
  });

  const [companyState, setCompanyState] = useState({
    title: '',
    taxOffice: '',
    taxNo: '',
    address: '',
    country: '',
    region: '',
    district: '',
    postalCode: '',
    position: '',
    sector: '',
    businessType: '',
    emergencyContactName: '',
    emergencyContactSurname: '',
    emergencyContactTitle: '',
    emergencyContactPhoneCode: '',
    emergencyContactPhone: '',
    isBuyer: false,
    isSeller: false,
    learnedFrom: '',
    machineParkSize: '',
  });

  useEffect(() => {
    const {
      id, email, phone, userToken,
    } = router.query;
    const membershipType = localStorage.getItem('membershipType');

    const dataToBeUpdate = {};

    if (id) {
      dataToBeUpdate.id = id;
    }
    if (userToken) {
      const decodedToken = jwtDecode(userToken);
      dataToBeUpdate.id = decodedToken.id;
    }
    if (membershipType !== null && step !== 'membership-type') {
      dataToBeUpdate.membershipType = membershipType;
    }
    if (email) {
      dataToBeUpdate.email = email;
    }
    if (phone) {
      dataToBeUpdate.phone = phone;
    }

    setUserState({
      ...userState,
      ...dataToBeUpdate,
    });
    setPageLoading(false);
    getSources();

    if (step === 'email-verify-success') {
      updateRegisterStep();
    }
  }, []);

  /*   useEffect(() => {
    const message = t('pageLeaveText');
    const handleRouteChange = (url) => {
      if (router.asPath !== url && !window.confirm(message)) {
        router.events.emit('routeChangeError');
        router.replace(router, router.asPath);
        // eslint-disable-next-line no-throw-literal
        throw 'Abort route change. Please ignore this error.';
      }
    };

    const beforeunload = (e) => {
      console.log(e);
      e.preventDefault();
      e.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', beforeunload);
    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      window.removeEventListener('beforeunload', beforeunload);
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, []); */

  const getSources = async () => {
    try {
      const { source: countries } = await getSource('country');
      const { source: regions } = await getSource('region');
      const { source: sectors } = await getSource('sector');
      const { source: businessTypes } = await getSource('businessType');
      const { source: taxOffices } = await getSource('taxOffice');
      const { source: learnedFroms } = await getSource('learnedFrom');
      const { source: districts } = await getSource('district');

      setSources({
        countries,
        regions,
        sectors,
        taxOffices,
        learnedFroms,
        businessTypes,
        districts,
      });
    } catch (error) {
      console.log('getSourcesErr', error);
    }
  };

  const updateCompanyState = ({ name, value }) => {
    if (name === 'region') {
      const districtByCountry = _.chain(sources).get('districts').filter((district) => district.region === value).sortBy('name')
        .value();
      setSources({
        ...sources,
        districtByRegion: districtByCountry,
      });
    }
    setCompanyState({
      ...companyState,
      [name]: value,
    });
  };

  const updateUserState = ({ name, value }) => {
    setUserState({
      ...userState,
      [name]: value,
    });
  };

  const componentParams = {
    userState,
    companyState,
    updateCompanyState,
    updateUserState,
    sources,
    router,
  };

  const steps = {
    'membership-type': {
      component: <MembershipType {...componentParams} />,
      index: 0,
    },
    'create-profile': {
      component: <CreateProfile {...componentParams} />,
      index: 1,
    },
    'email-verification': {
      component: <EmailVerification {...componentParams} />,
      index: 2,
    },
    'email-verify-success': {
      component: <EmailVerifySuccess {...componentParams} />,
      index: 2,
    },
    'phone-enterence': {
      component: <PhoneEnterence {...componentParams} />,
      index: 3,
    },
    'code-enterence': {
      component: <CodeEnterence {...componentParams} />,
      index: 3,
    },
    'create-company': {
      component: <CreateCompany {...componentParams} />,
      index: 4,
    },
  };

  if (pageLoading) {
    return null;
  }

  return (
    <>
      {
        step === 'register-success'
          ? <RegisterSuccess />
          : (
            <main className="has-header">
              <div className="container pt-3">
                <div className="row">
                  <RegisterSteps currentStep={steps[step].index} membershipType={userState.membershipType} />
                  {steps[step].component}
                </div>
              </div>
            </main>
          )
      }
    </>
  );
};

Register.propTypes = {
  step: PropTypes.string,
};

export const getServerSideProps = async ({ query, res, req }) => {
  const step = query?.step;
  const token = req?.cookies?.registerStep;

  if ((!_.includes(['membership-type', 'create-profile', 'email-verification', 'email-verify-success', 'phone-enterence', 'code-enterence', 'register-success', 'create-company'], step))
  || (_.includes(['email-verification', 'email-verify-success', 'phone-enterence', 'code-enterence', 'register-success', 'create-company'], step) && !checkRegisterStep({ token, ...query }))) {
    res.writeHead(302, { Location: '/404' });
    res.end();
  }

  return {
    props: {
      shortHeader: true,
      shortFooter: true,
      headTitle: 'Üye Ol',
      step,
    },
  };
};

Register.Layout = Layout;

export default Register;
